import { DeleteOutlined } from "@ant-design/icons";
import { FC, useCallback } from "react";

import { useResetApp } from "@/hooks/app/useResetApp";
import BaseButton from "@/shared/ui/BaseButton";
import { BaseModal } from "@/shared/ui/BaseModal";

interface DayStartedModalProps {
    onClose: () => void;
}

export const DayStartedModal: FC<DayStartedModalProps> = ({ onClose }) => {
    const { handleReset } = useResetApp();

    const handleClickReset = useCallback(() => {
        onClose();
        handleReset();
    }, [handleReset, onClose]);

    return (
        <BaseModal
            title={"День уже розпочато"}
            open
            onClose={onClose}
            actions={null}
            closable={false}
            mask={{ closable: false }}
        >
            <BaseButton
                type="primary"
                icon={<DeleteOutlined />}
                onClick={handleClickReset}
            >
                Скинути кеш
            </BaseButton>

            <BaseButton type="default" onClick={onClose}>
                Повернутися назад
            </BaseButton>
        </BaseModal>
    );
};
